import { COUPON_DISCOUNT_TYPE_V2, COUPON_STATUS_V2, COUPON_TYPE_V2 } from '../../../types/coupons';

export const COUPON_DISCOUNT_TYPE_LABEL_V2 = {
  [COUPON_DISCOUNT_TYPE_V2.AMOUNT]: '정액 할인',
  [COUPON_DISCOUNT_TYPE_V2.RATE]: '정률 할인',
};

export const COUPON_DISCOUNT_UNIT_V2 = {
  [COUPON_DISCOUNT_TYPE_V2.RATE]: '%',
  [COUPON_DISCOUNT_TYPE_V2.AMOUNT]: '원',
};

export const COUPON_DISCOUNT_TYPE_SELECT_LIST_V2 = Object.values(COUPON_DISCOUNT_TYPE_V2).map((type) => ({
  id: type,
  name: COUPON_DISCOUNT_TYPE_LABEL_V2[type],
}));

export const COUPON_STATUS_LABEL_V2 = {
  [COUPON_STATUS_V2.INACTIVE]: '비활성',
  [COUPON_STATUS_V2.ACTIVE]: '활성',
};

export const COUPON_STATUS_SELECT_LIST_V2 = Object.values(COUPON_STATUS_V2).map((status) => ({
  id: status,
  name: COUPON_STATUS_LABEL_V2[status],
}));

export const COUPON_TYPE_LABEL_V2 = {
  [COUPON_TYPE_V2.ALL_PRODUCT_LIST]: '전체 상품 쿠폰',
  [COUPON_TYPE_V2.TARGET_PRODUCT]: '특정 상품 쿠폰',
  [COUPON_TYPE_V2.TARGET_STORE]: '특정 브랜드 쿠폰',
};

export const COUPON_TYPE_SELECT_LIST_V2 = Object.values(COUPON_TYPE_V2).map((type) => ({
  id: type,
  name: COUPON_TYPE_LABEL_V2[type],
}));
